export default "__VITE_ASSET__B14hGBR0__"